module.exports = __webpack_public_path__ + "static/media/facebookThumnail-Edu-1200X630.e788a1ec.png";